export default "__VITE_ASSET__xS7C1whC_KyBFfbMt$qL3g__"